<lib-footer
  class="footer"
  [variant]="variant"
  [date]="now()"
  [status]="connectionStatus"
  [isConnectedFlag]="isConnected"
  [customCopyright]="copyrightText"
  [productName]="'Nebula Vault'"
  [tenantName]="getDisplayTenant()"
  [displayTenant]="displayTenant && showTenant()"
></lib-footer>
